import React from 'react'
import styles from './styles'
import { withStyles, Typography, Divider } from '@material-ui/core'
import { useSelector } from 'react-redux'
import { CoreButton, CoreTextField } from 'src/components/core'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import URLs from 'src/api/url'
import { Icon } from '@iconify/react'

const IframeViewCourse = props => {
  const { classes } = props
  const [copiedEmbedCode, setCopiedEmbedCode] = React.useState(false)
  const entity = useSelector(state => state.course.course)

  const onClickEmbedCode = () => {
    setCopiedEmbedCode(true)
    setTimeout(() => {
      setCopiedEmbedCode(false)
    }, 500)
  }

  return (
    <div className={classes.customDomain__root}>
      <Typography className={classes.embedInstructionText}>
        You can embed the course on your website with JavaScript code.
      </Typography>
      <Typography className={classes.embedInstructionText}>
        Add the following codes to the
        <span className={classes.headTagHighlight}>{' <head> '}</span> tag of
        your site.
      </Typography>
      <CoreTextField
        fullWidth
        marginTop={false}
        value={
          '<div id="iframe_container" style="width: 100%;position: relative;overflow: hidden;padding-top: 100%;"><iframe id="mcg" name="mcg_frame" title="Mini-Course" src="' +
          '' +
          URLs.APP_URL +
          '' +
          entity.code +
          '" align="center" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"  style="position: absolute; width: 100%;height: 100%;top: 0;right: 0;bottom: 0;left: 0;border: none;margin: 0px;padding: 0px;"></iframe></div>'
        }
      />

      <CopyToClipboard
        text={
          '<div id="iframe_container" style="width: 100%;position: relative;overflow: hidden;padding-top: 100%;"><iframe id="mcg" name="mcg_frame" title="Mini-Course" src="' +
          '' +
          URLs.APP_URL +
          '' +
          entity.code +
          '" align="center" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"  style="position: absolute; width: 100%;height: 100%;top: 0;right: 0;bottom: 0;left: 0;border: none;margin: 0px;padding: 0px;"></iframe></div>'
        }
      >
        <CoreButton
          onClick={onClickEmbedCode}
          variant="contained"
          color="primary"
          fullWidth
        >
          {copiedEmbedCode ? 'Copied!' : 'Copy Code'}
        </CoreButton>
      </CopyToClipboard>
      <Divider />
      <div
        className={classes.wordpressPluginContainer}
        onClick={() => {
          window.open(
            'https://wordpress.org/plugins/mini-course-generator/',
            '_blank',
          )
        }}
      >
        <Icon icon="ic:baseline-wordpress" color="#0073AA" fontSize={16} />
        <Typography className={classes.wordpressPluginText}>
          Install MCG WordPress plug-in
        </Typography>
        <Icon icon="ic-round-chevron-right" fontSize={16} />
      </div>
    </div>
  )
}

export default withStyles(styles)(IframeViewCourse)
